import { render, staticRenderFns } from "./AdminsInfo.vue?vue&type=template&id=01ffd1f2&scoped=true&"
import script from "./AdminsInfo.vue?vue&type=script&lang=ts&"
export * from "./AdminsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffd1f2",
  null
  
)

export default component.exports